import React, { useState, useEffect } from 'react';
import { users } from './Users';
import AdminLogin from './AdminLogin'; // AdminLogin importieren
import axios from 'axios';
import socket, { API_BASE_URL } from './config/socket';



const AdminView = () => {
  const [teams, setTeams] = useState([]);
  const [authenticated, setAuthenticated] = useState(false);
  const [team1, setTeam1] = useState('Team 1');
  const [team2, setTeam2] = useState('Team 2');


  // Das Admin-Passwort wird nach dem Login im Speicher gehalten, damit RCON-Befehle
  // sich am Backend ausweisen koennen. Es wird nirgends persistiert.
  const [adminPassword, setAdminPassword] = useState('');

  const handleLogin = (password) => {
    setAdminPassword(password);
    setAuthenticated(true);
  };

  const generateTeams = () => {

    if (!teams.length) {

      const shuffledUsers = [...users].sort(() => 0.5 - Math.random());
      const team1 = shuffledUsers.slice(0, Math.ceil(users.length / 2));
      const team2 = shuffledUsers.slice(Math.ceil(users.length / 2));
      const newTeams = [team1, team2];
      setTeams(newTeams);
      socket.emit('updateTeams', newTeams);
    }
    else {

      const flatarray = teams.flat();
      const shuffledUsers = [...flatarray].sort(() => 0.5 - Math.random());
      const team1 = shuffledUsers.slice(0, Math.ceil(flatarray.length / 2));
      const team2 = shuffledUsers.slice(Math.ceil(flatarray.length / 2));
      const newTeams = [team1, team2];
      setTeams(newTeams);
      socket.emit('updateTeams', newTeams);
    }

  };


  useEffect(() => {
    socket.on('updateTeams', (newTeams) => {
      setTeams(newTeams);
      //  console.log ("feuer")
    });

    return () => {
      socket.off('updateTeams');
    };
  }, []);



  const handleOnBlur = () =>{
    console.log('Input blurred')
    console.log(team1)
    socket.emit('updateTeam1', team1);
  };

  const handleChange = (e) => {
    setTeam1(e.target.value);
  }

  const handleOnBlur1 = () =>{
    console.log('Input blurred')
    console.log(team2)
    socket.emit('updateTeam2', team2);
  };

  const handleChange1 = (e) => {
    setTeam2(e.target.value);
  }

  const [checked, setChecked] = React.useState(false);

  const handleChange2 = () => {
    setChecked(!checked);
    socket.emit('ready', !checked);
    socket.emit('fetch_player_stats');
    socket.emit('fetch_playermatch_stats');
    socket.emit('fetch_match_stats');
  };



  const [command, setCommand] = useState('');
  const [response, setResponse] = useState('');

  // const sendCommand = async () => {
  //   try {
  //     const res = await axios.post('http://localhost:4000/send-rcon', { command });
  //     // const res = await axios.post('https://otterschlacht.com/send-rcon', { command });
  //     setResponse(res.data.response);
  //   } catch (error) {
  //     setResponse(`Fehler: ${error.message}`);
  //   }
  // };

  const sendCommand = async (cmd) => {
    try {
      const commandToSend = cmd || command; // Verwende den übergebenen Befehl oder den aktuellen Zustand
      const res = await axios.post(`${API_BASE_URL}/send-rcon`, {
        command: commandToSend,
        password: adminPassword, // Backend prueft das Passwort
      });
      setResponse(res.data.response);
    } catch (error) {
      if (error.response?.status === 401) {
        setResponse('Nicht autorisiert - bitte neu einloggen');
      } else {
        setResponse(`Fehler: ${error.message}`);
      }
    }
  };



  // useEffect(() => {
  //   console.log(teams);  // Dieser Effekt wird ausgeführt, wenn teams sich ändern

  // }, [teams]);



  const [deactivated, setDeactivated] = useState([]);


  useEffect(() => {
    socket.on('deactivate', (Newdeactivated) => {
      if (deactivated.length === 0) { // Überprüfen, ob deactivated leer ist
        setDeactivated(Newdeactivated);
        console.log("feuer");
      }
    });
    return () => {
      socket.off('deactivate'); // Hier sollte 'deactivate' statt 'updateTeams' stehen
    };

  }, [deactivated]);


  const deleteMember = (teamIndex, memberIndex) => {
    setTeams((prevTeams) => {
      // Hole das gelöschte Mitglied
      const memberToDelete = prevTeams[teamIndex][memberIndex];

      // Füge das Mitglied zu deactivated hinzu (einmalig!)
      setDeactivated((prevDeactivated) => {
        if (!prevDeactivated.includes(memberToDelete)) {
          const updatedDeactivated = [...prevDeactivated, memberToDelete];
          socket.emit('deactivate', updatedDeactivated); // Sende das aktualisierte Array
          return updatedDeactivated;
        }
        return prevDeactivated;
      });

      // Entferne das Mitglied aus dem Team
      const updatedTeams = prevTeams.map((team, index1) =>
        index1 === teamIndex
          ? team.filter((_, i) => i !== memberIndex) // Entferne das Mitglied
          : team // Unveränderte Teams
      );

      // Sende das neue Team-Array an den Server
      socket.emit('updateTeams', updatedTeams);

      return updatedTeams; // Gib die aktualisierten Teams zurück
    });
  };


  const activateMember = (memberToActivate) => {
    // Aktualisiere deactivated
    setDeactivated((prevDeactivated) => {
      const updatedDeactivated = prevDeactivated.filter((member) => member !== memberToActivate);
      socket.emit('deactivate', updatedDeactivated); // Sende das aktualisierte deactivated-Array
      return updatedDeactivated;
    });

    // Aktualisiere teams
    setTeams((prevTeams) => {
      const updatedTeams = prevTeams.map((team, index) => {
        if (index === 0) {
          return [...team, memberToActivate]; // Füge das Mitglied zum Team 0 hinzu
        }
        return team; // Andere Teams unverändert
      });
      socket.emit('updateTeams', updatedTeams); // Sende das aktualisierte Teams-Array
      return updatedTeams;
    });
  };



  const [showForm, setShowForm] = useState(false);
  const [newUser, setNewUser] = useState({
    name: '',
    nickName: '',
    imgUrl: '',
    steamID: '',
  });


  const addNewUser = () => {
    setDeactivated((prevDeactivated) => {
      const updatedDeactivated = [...prevDeactivated, newUser];
      socket.emit('deactivate', updatedDeactivated); // Sende das aktualisierte deactivated-Array an den Server
      return updatedDeactivated;
    });

    // Felder zurücksetzen und Formular ausblenden
    setNewUser({ name: '', nickName: '', imgUrl: '', steamID: '' });
    setShowForm(false);
  };



  return (
    <div>
      {!authenticated ? (
        <AdminLogin onLogin={handleLogin} /> // `onLogin` korrekt übergeben
      ) : (
        <div className='mx-auto max-w-2xl py-24 sm:py-24 lg:py-24'>
          <h1 className='text-2xl pb-6'>Team Generator (Admin)</h1>
          <div className='mt-12 grid grid-cols-1 sm:grid-cols-3 gap-y-3 gap-x-4'>
            <button className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" onClick={generateTeams}>Teams generieren</button>
            <div></div>
            <Checkbox
              label="Ready"
              value={checked}
              onChange={(event) => {
                handleChange2(event);
                if (event.target.checked) {
                  const newCommand = `matchzy_loadmatch_url "${window.location.origin}/match.json"`;
                  setCommand(newCommand);
                  sendCommand(newCommand); // Übergebe den neuen Befehl direkt
                }
              }}
            />

          </div>
          {teams.length > 0 && (
            <div className='mt-12 grid grid-cols-1 sm:grid-cols-3 gap-y-3 gap-x-4'>
              <div>
                <input className='mb-8 text-xl font-bold' onBlur={handleOnBlur} onChange={handleChange} name="myInput" value={team1}></input>
                <ul>
                  {teams[0].map((user, index) => (
                    <li key={index} onClick={() => deleteMember(0, index)}>
                      <div className='flex flex-row mb-4'>
                        <img src={user.imgUrl} alt={user.nickName} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                        <span className='ml-2 my-auto'>{user.nickName} ({user.name})</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h2 className='p-4 sm:p-16 text-3xl font-bold'>VS</h2>
              </div>
              <div>
                <input className='mb-8 text-xl font-bold' onBlur={handleOnBlur1} onChange={handleChange1} name="myInput" value={team2}></input>
                <ul>
                  {teams[1].map((user, index) => (
                    <li key={index} onClick={() => deleteMember(1, index)}>
                      <div className='flex flex-row mb-4'>
                        <img src={user.imgUrl} alt={user.nickName} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                        <span className='ml-2 my-auto'>{user.nickName} ({user.name})</span>
                        </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h1>CS2 RCON Console</h1>
                <textarea
                  placeholder="Befehl eingeben..."
                  value={command}
                  onChange={(e) => setCommand(e.target.value)}
                />
                <button onClick={() => sendCommand(command)}>Senden</button>
                <pre>{response}</pre>
              </div>
            </div>
          )}
                  <h3>Deactivated Members:</h3>
                  <ul>
                    {deactivated.map((member, index) => (
                      <li key={index} onClick={() => activateMember(member)}>
                        {member.name} ({member.nickName})
                      </li>
                    ))}
                    <li onClick={() => setShowForm(true)} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                      + Add User
                    </li>
                  </ul>

                {showForm && (
                  <div style={{ marginTop: '10px', padding: '10px', border: '1px solid #ccc' }}>
                    <h4>Add New User</h4>
                    <label>
                      Name:
                      <input
                        type="text"
                        value={newUser.name}
                        onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
                      />
                    </label>
                    <br />
                    <label>
                      Nickname:
                      <input
                        type="text"
                        value={newUser.nickName}
                        onChange={(e) => setNewUser({ ...newUser, nickName: e.target.value })}
                      />
                    </label>
                    <br />
                    <label>
                      Image URL:
                      <input
                        type="text"
                        value={newUser.imgUrl}
                        onChange={(e) => setNewUser({ ...newUser, imgUrl: e.target.value })}
                      />
                    </label>
                    <br />
                    <label>
                      Steam ID:
                      <input
                        type="text"
                        value={newUser.steamID}
                        onChange={(e) => setNewUser({ ...newUser, steamID: e.target.value })}
                      />
                    </label>
                    <br />
                    <button onClick={addNewUser}>Add to Deactivated</button>
                    <button onClick={() => setShowForm(false)}>Cancel</button>
                  </div>
                )}

        </div>



      )
      }
    </div>
  );
};

const Checkbox = ({ label, value, onChange }) => {
  return (
    <label>
      <input type="checkbox" checked={value} onChange={onChange} />
      {label}
    </label>
  );
};




export default AdminView;
